import React from "react";
import { RouterProvider, createBrowserRouter, createHashRouter, Navigate } from "react-router-dom";
import { ROUTES } from "./const";
import LoginPage from "./components/pages/Login/Login";
import ErrorPage from "./components/pages/ErrorPage/ErrorPage";
import SalesPage from "./components/pages/Sales/Sales";
import PrivateRoute from "./components/utils/PrivateRoute";
import BillNumberPage from "./components/pages/InvoiceNumberSetUpPage/InvoiceNumberSetUpPage";
import RootLayout from "./components/layout/RootLayout/RootLayout";
import PopupLayout from "./components/layout/PopupLayout/PopupLayout";
import PosLayout from "./components/layout/PosLayout/PosLayout";
import ShiftPage from "./components/pages/Shift/Shift";
import { UserProvider } from "./context/UserContext";
import { ShopProvider } from "./context/ShopContext";
import { SalesProvider } from "./context/SalesContext";
import { ProductProvider } from "./context/ProductContext";
import { CustomerProvider } from "./context/CustomerContext";
import ShopPage from "./components/pages/Shop/ShopSelecctionPage";
import CounterPage from "./components/pages/TerminalSelection/TerminalSelection";
import ManageLayout from "./components/layout/ManageLayout/ManageLayout";
import LabelScalePage from "./components/pages/Servers/LabelScale";
import KOTPage from "./components/pages/Servers/KOT";
// import BluetoothScalePage from "./components/pages/Servers/BluetoothScale";
import SalesPersonPage from "./components/pages/SalesPerson/SalesPerson";
import TaxSettingsPage from "./components/pages/Settings/Tax";
import CategoryAndProductManagePage from "./components/pages/CategoryAndProductManagePage/CategoryAndProductManagePage";
import ActiveOrdersPage from "./components/pages/ActiveOrders/ActiveOrders";
import SalesReportPage from "./components/pages/SalesReports/SalesReports";
import PayPage from "./components/pages/Paypage/Paypage";
import LockScreenPage from "./components/pages/lockPage/LockPage";
import CustomersPage from "./components/pages/Customers/Customers";
import CustomerDetailsPage from "./components/pages/Customers/CustomerDetails";
import LicenceSetup from "./components/pages/LicenceSetup/LicenceSetup";
import AuthRedirect from "./components/utils/AuthRedirect";
import { Toaster } from "react-hot-toast";
import TableDashboard from "./components/pages/TableDashboard/TableDashboard";
import SubMenuLayout from "./components/layout/SubMenuLayout/SubMenuLayout";
import BasicSettings from "./components/pages/Settings/BasicSettings";
import SystemConfigurationPage from "./components/pages/Settings/SystemConfigurationPage";
import InvoicePrintersPage from "./components/pages/Printers/InvoicePrintersPage";
import InvoiceSettingsPage from "./components/pages/Settings/InvoiceSettingsPage";
import PaymentMode from "./components/pages/Payment Mode/paymentMode";
import AboutSanoftPage from "./components/pages/AboutSanoft/AboutSanoft";
import KotFormatPage from "./components/pages/Printers/KotFormatPage";
import BarcodePrintersPage from "./components/pages/Printers/BarcodePrinterPage";
import NetworkPrinterQueuePage from "./components/pages/Printers/PrinterQueuesPage";
import { SalesPersonProvider } from "./context/SalesPersonContext";
import { SearchProvider } from "./context/SearchContext";
import { AreaTableProvider } from "./context/AreaTableContext";
import { TerminalProvider } from "./context/TerminalContext";
import ERPDashBoardPage from "./components/pages/ERP/ERPDashBoardPage";
import SubscriptionExpired from "./components/pages/SubscriptionExpired/SubscriptionExpired";
import ShopDetails from "./components/pages/Settings/ShopDetails";
import BatchBarcodeConfig from "./components/pages/Settings/BatchBarcodeConfig";
import PurchasePage from "./components/pages/Purchase/PurchasePage";
import NewPurchasePage from "./components/pages/Purchase/NewPurchasePage";
import DraftPurchasePage from "./components/pages/Purchase/DraftPurchasePage";
import StockDamagesPage from "./components/pages/StockDamages/StockDamages";
import DraftStockDamagesPage from "./components/pages/StockDamages/DraftStockDamages";
import AddStockDamagePage from "./components/pages/StockDamages/AddStockDamage";
import * as NativeApiServer from "./utils/server/NativeApiServer";
import VendorsPage from "./components/pages/Vendors/VendorsPage";
import VendorDetailsPage from "./components/pages/Vendors/VendorDetails";
import OnlineOrdersPage from "./components/pages/OnlineOrders/OnlineOrdersPage";
import { VendorProvider } from "./context/VendorContext";
import { CommonProvider } from "./context/CommonContext";
import { NotificationProvider } from "./context/NotificationContext";
import { OnlineOrderProvider } from "./context/OnlineOrderContext";
import NotificationHandler from "utils/NotificationHandler";
import { PrinterManager } from "managers/PrinterManager";
import WebSocketGatewayService from "services/WebSocketGatewayService";

const creatRouterFnction = process.env.REACT_APP_ROUTER_TYPE === "hash" ? createHashRouter : createBrowserRouter;

const router = creatRouterFnction([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <AuthRedirect /> },
      { path: `${ROUTES.LOGIN}`, element: <LoginPage /> },
      { path: `${ROUTES.LICENCE_SETUP}`, element: <LicenceSetup /> },
    ],
  },
  {
    path: "/",
    element: (
      <ShopProvider>
        <UserProvider>
          <SalesPersonProvider>
            <RootLayout />
          </SalesPersonProvider>
        </UserProvider>
      </ShopProvider>
    ),
    children: [
      {
        path: `${ROUTES.LOCK_SCREEN}`,
        element: <PrivateRoute element={LockScreenPage} />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <ShopProvider>
        <UserProvider>
          <SalesPersonProvider>
            <PopupLayout />
          </SalesPersonProvider>
        </UserProvider>
      </ShopProvider>
    ),
    children: [
      {
        path: `${ROUTES.SELECT_SHOP}`,
        element: <PrivateRoute element={ShopPage} />,
      },
      {
        path: `${ROUTES.COUNTER}`,
        element: <PrivateRoute element={CounterPage} />,
      },
      {
        path: `${ROUTES.BILL_NUMBER}`,
        element: <PrivateRoute element={BillNumberPage} />,
      },
      {
        path: `${ROUTES.SHIFT}`,
        element: <PrivateRoute element={ShiftPage} />,
      },
      {
        path: `${ROUTES.SUBSCRIPTION_EXPIRED}`,
        element: <SubscriptionExpired />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <ShopProvider>
        <AreaTableProvider>
          <UserProvider>
            <ProductProvider>
              <CustomerProvider>
                <VendorProvider>
                  <SalesProvider>
                    <SalesPersonProvider>
                      <SearchProvider>
                        <TerminalProvider>
                          <PosLayout />
                        </TerminalProvider>
                      </SearchProvider>
                    </SalesPersonProvider>
                  </SalesProvider>
                </VendorProvider>
              </CustomerProvider>
            </ProductProvider>
          </UserProvider>
        </AreaTableProvider>
      </ShopProvider>
    ),
    children: [
      {
        path: `${ROUTES.TABLE_DASHBOARD}`,
        element: <PrivateRoute element={TableDashboard} />,
      },
      {
        path: `${ROUTES.SALES}`,
        element: <PrivateRoute element={SalesPage} />,
      },
      {
        path: `${ROUTES.ERP_DASHBOARD}`,
        element: <PrivateRoute element={ERPDashBoardPage} />,
      },
      {
        path: `${ROUTES.ACTIVE_ORDERS}`,
        element: <PrivateRoute element={ActiveOrdersPage} />,
      },
      {
        path: `${ROUTES.CUSTOMERS}`,
        element: <PrivateRoute element={CustomersPage} />,
      },
      {
        path: `${ROUTES.CUSTOMER_DETAILS}`,
        element: <PrivateRoute element={CustomerDetailsPage} />,
      },
      {
        path: `${ROUTES.REPORT}`,
        element: <PrivateRoute element={SalesReportPage} />,
      },
      {
        path: `${ROUTES.PAYPAGE}`,
        element: <PrivateRoute element={PayPage} />,
      },
      {
        path: `${ROUTES.PURCHASE}`,
        element: <PrivateRoute element={PurchasePage} />,
      },
      {
        path: `${ROUTES.NEW_PURCHASE}`,
        element: <PrivateRoute element={NewPurchasePage} />,
      },
      {
        path: `${ROUTES.EDIT_PURCHASE}`,
        element: <PrivateRoute element={NewPurchasePage} />,
      },
      {
        path: `${ROUTES.DRAFT_PURCHASES}`,
        element: <PrivateRoute element={DraftPurchasePage} />,
      },
      {
        path: `${ROUTES.EDIT_DRAFT_PURCHASE}`,
        element: <PrivateRoute element={NewPurchasePage} />,
      },
      {
        path: `${ROUTES.STOCK_DAMAGES}`,
        element: <PrivateRoute element={StockDamagesPage} />,
      },
      {
        path: `${ROUTES.DRAFT_STOCK_DAMAGES}`,
        element: <PrivateRoute element={DraftStockDamagesPage} />,
      },
      {
        path: `${ROUTES.ADD_STOCK_DAMAGE}`,
        element: <PrivateRoute element={AddStockDamagePage} />,
      },
      {
        path: `${ROUTES.VENDORS}`,
        element: <PrivateRoute element={VendorsPage} />,
      },
      {
        path: `${ROUTES.VENDOR_DETAILS}`,
        element: <PrivateRoute element={VendorDetailsPage} />,
      },
      {
        path: `${ROUTES.ONLINE_ORDERS}`,
        element: <PrivateRoute element={OnlineOrdersPage} />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <ShopProvider>
        <TerminalProvider>
          <AreaTableProvider>
            <UserProvider>
              <ProductProvider>
                <SalesProvider>
                  <SearchProvider>
                    <SalesPersonProvider>
                      <ManageLayout />
                    </SalesPersonProvider>
                  </SearchProvider>
                </SalesProvider>
              </ProductProvider>
            </UserProvider>
          </AreaTableProvider>
        </TerminalProvider>
      </ShopProvider>
    ),
    children: [
      {
        path: `${ROUTES.PRODUCTS}`,
        element: <PrivateRoute element={CategoryAndProductManagePage} />,
      },
      {
        path: `${ROUTES.MANAGE}`,
        element: <PrivateRoute element={() => null} />,
      },
      {
        path: `${ROUTES.SERVERS}`,
        element: (
          <PrivateRoute
            element={() => (
              <SubMenuLayout
                menuItems={[
                  { id: "kot_server", name: "KOT Server", path: ROUTES.KOT },
                  { id: "label_scale", name: "Label Scale", path: ROUTES.LABEL_SCALE },
                  // { id: "bluetooth_scale", name: "Bluetooth Scale", path: ROUTES.BLUETOOTH_SCALE },
                ]}
              />
            )}
          />
        ),
        children: [
          { index: true, element: <Navigate to={ROUTES.KOT} replace /> },
          { path: ROUTES.KOT, element: <PrivateRoute element={KOTPage} /> },
          { path: ROUTES.LABEL_SCALE, element: <PrivateRoute element={LabelScalePage} /> },
          // { path: ROUTES.BLUETOOTH_SCALE, element: <PrivateRoute element={BluetoothScalePage} /> },
        ],
      },
      {
        path: `${ROUTES.PRINTERS}`,
        element: (
          <PrivateRoute
            element={() => (
              <SubMenuLayout
                menuItems={[
                  { id: "invoicePrinters", name: "Invoice Printers", path: "invoice-printers" },
                  { id: "kotFormat", name: "KOT Format", path: "kot-format" },
                  { id: "barcodePrinter", name: "Barcode Printer", path: "barcode-printer" },
                  { id: "networkPrinterQueue", name: "Network Printer Queue ", path: "network-printer-queue" },
                ]}
              />
            )}
          />
        ),
        children: [
          { index: true, element: <Navigate to="invoice-printers" replace /> },
          { path: "invoice-printers", element: <PrivateRoute element={InvoicePrintersPage} /> },
          { path: "kot-format", element: <PrivateRoute element={KotFormatPage} /> },
          { path: "barcode-printer", element: <PrivateRoute element={BarcodePrintersPage} /> },
          { path: "network-printer-queue", element: <PrivateRoute element={NetworkPrinterQueuePage} /> },
        ],
      },
      {
        path: `${ROUTES.SALESPERSON}`,
        element: <PrivateRoute element={SalesPersonPage} />,
      },
      {
        path: `${ROUTES.PAYMENT_MODE}`,
        element: <PrivateRoute element={PaymentMode} />,
      },
      {
        path: `${ROUTES.ABOUT_US}`,
        element: <PrivateRoute element={AboutSanoftPage} />,
      },
      {
        path: `${ROUTES.SETTINGS}`,
        element: (
          <PrivateRoute
            element={() => (
              <SubMenuLayout
                menuItems={[
                  { id: "basicSettings", name: "Basic Settings", path: "basic-settings" },
                  { id: "tax", name: "Tax", path: "tax" },
                  { id: "systemConfiguration", name: "System Configuration", path: "system-configuration" },
                  { id: "batchBarcodeConfig", name: "Batch Barcode Config", path: "batch-barcode-config" },
                  { id: "invoice", name: "Invoice", path: "invoice" },
                  { id: "shopDetails", name: "Shop Details", path: "shop-details" },
                ]}
              />
            )}
          />
        ),
        children: [
          { index: true, element: <Navigate to="basic-settings" replace /> },
          { path: "basic-settings", element: <PrivateRoute element={BasicSettings} /> },
          { path: "system-configuration", element: <PrivateRoute element={SystemConfigurationPage} /> },
          { path: "tax", element: <PrivateRoute element={TaxSettingsPage} /> },
          { path: "invoice", element: <PrivateRoute element={InvoiceSettingsPage} /> },
          { path: "shop-details", element: <PrivateRoute element={ShopDetails} /> },
          { path: "batch-barcode-config", element: <PrivateRoute element={BatchBarcodeConfig} /> },
        ],
      },
    ],
  },
  {
    path: "/",
    element: <RootLayout />,
    children: [{ path: "*", element: <ErrorPage /> }],
  },
]);

function App() {
  React.useEffect(() => {
    // Initialize the global object immediately
    window.nativeApi = window.nativeApi || {};
    window.nativeApi.handleRequest = NativeApiServer.handleRequest;
    window.nativeApi.notificationTokenGenerated = NotificationHandler.notificationTokenGenerated;
    window.nativeApi.notificationReceived = NotificationHandler.notificationReceived;
    window.nativeApi.onWebSocketEvent = (eventType, connectionId, data) => {
      WebSocketGatewayService.handleNativeEvent(eventType, connectionId, data);
    };

    PrinterManager.start();
  }, []);
  return (
    <CommonProvider>
      <NotificationProvider>
        <OnlineOrderProvider>
          <RouterProvider router={router} />
          <Toaster position="top-center" reverseOrder={false} />
        </OnlineOrderProvider>
      </NotificationProvider>
    </CommonProvider>
  );
}

export default App;
